import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircle } from 'lucide-react';
export function Identification() {
  const painPoints = ['No saben qué vender', 'Tienen miedo de perder dinero', 'Se sienten confundidas con tanta información'];
  return <section className="bg-brand-beige py-20 px-6" data-id="element-211">
      <div className="max-w-6xl mx-auto" data-id="element-212">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-213">
          {/* LEFT COLUMN — All text content */}
          <div className="flex-1 w-full" data-id="element-214">
            <FadeIn data-id="element-215">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-6" data-id="element-216">
                Si estás aquí es porque sabes que necesitas una forma real de
                generar ingresos desde casa…
              </h2>
              <p className="text-lg text-brand-text/70 mb-4" data-id="element-217">
                Pero no sabes por dónde empezar o ya has intentado otras cosas
                sin resultados.
              </p>
              <p className="text-lg text-brand-text/70 mb-10" data-id="element-218">
                Este sistema fue creado para ayudarte a entender cómo funciona
                Amazon desde adentro, para que dejes de adivinar y empieces con
                claridad.
              </p>
            </FadeIn>

            <div className="space-y-4 mb-10" data-id="element-219">
              {painPoints.map((point, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-220">
                  <div className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-sm border border-brand-green/5" data-id="element-221">
                    <div className="flex-shrink-0 w-10 h-10 bg-brand-beige rounded-full flex items-center justify-center" data-id="element-222">
                      <AlertCircle className="w-5 h-5 text-brand-gold" data-id="element-223" />
                    </div>
                    <p className="text-lg text-brand-text font-medium" data-id="element-224">
                      {point}
                    </p>
                  </div>
                </FadeIn>)}
            </div>

            <FadeIn delay={0.5} data-id="element-225">
              <div className="space-y-4 text-xl md:text-2xl font-serif text-brand-green text-center" data-id="element-226">
                <p data-id="element-227">
                  No necesitas experiencia previa. No necesitas inventar nada.
                </p>
                <p className="font-bold" data-id="element-228">Solo seguir el paso a paso.</p>
              </div>
            </FadeIn>
          </div>

          {/* RIGHT COLUMN — Image only */}
          <div className="flex-shrink-0 w-full lg:w-[40%]" data-id="element-229">
            <FadeIn delay={0.3} data-id="element-230">
              <img src="https://cdn.magicpatterns.com/uploads/iKJ3MUFSanJqHtjyLiZNxg/ChatGPT_Image_6_abr_2026,_21_05_48.png" alt="Mujer trabajando desde casa con laptop en ambiente cálido" className="w-full h-auto rounded-2xl shadow-lg object-contain" data-id="element-231" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}